/* eslint-disable no-unused-vars */
// NPM imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import ReactHtmlParser from "react-html-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "../../revvComponents";

// Component Imports
import SeeAllPlansPopup from "../SeeAllPlansPopup";
import PlanChangeRequest from "../../components/SettingsWrapper/BillingSettings/PlanChangeRequest";

// Internal Imports
import { GlobalUtils } from "../../utils";
import { FEATURES, BILLING } from "../../constants";

// Action Imports
import { getSubscriptionCheckoutSessionID } from "../../actions/SettingsActions/settingsActions";
import { fetchPricingInfoAction } from "../../actions/CommonActions/commonActions";

// Service Imports
import { eventsTrackingApi } from "../../actions/CommonActions/commonService";
import { buttonClickEvent, customGAEvent } from "../../gtm/gtmutils";
import GTM_EVENTS from "../../gtm/gtmevents";
import { GTM_CUSTOM_EVENTS, GTM_EVENT_PARAMS } from "../../gtm/gtmcustomevents";

// Destructuring
const { readDataFromLocalStorage, writeDataToLocalStorage } = GlobalUtils;
const { UPGRADE_POPUP_TYPE } = FEATURES;
const { PLAN_NAMES } = BILLING;

class UpgradePopUpV2 extends Component {
  state = {
    showAllPlansModal: false,
    showContactUsModal: false,
    selectedPeriod: null,
    selectedPlan: "Premium",
    selectedPlanAlias: "revv-premium-annual-10-21",
  };

  componentDidMount() {
    if (this.props.pricingPlans && this.props.data) {
      this._onInit();
    } else {
      this.props
        .fetchPricingInfoAction()
        .then(() => this._onInit())
        .catch();
    }
  }

  _onInit = () => {
    const { data, pricingPlans, type } = this.props;
    const planName = this._getPlanName(data.planInfo.upgradeTo);
    this.setState(
      {
        selectedPeriod: pricingPlans[planName].bestValue,
      },
      () => eventsTrackingApi(UPGRADE_POPUP_TYPE[type].eventName),
    );
  };

  _getPlanName = planName => {
    if (planName) {
      return planName;
    }
    return this.props.planMapping[PLAN_NAMES[this.props.currentPlan]];
  };

  _toggleModal = stateName => {
    if (stateName === "showAllPlansModal" && !this.state.showAllPlansModal) {
      buttonClickEvent(GTM_EVENTS.UPGRADEPLANPOPUP_VIEW_ALL_PLANS_CLICK);
    }
    if (stateName === "showContactUsModal") {
      buttonClickEvent(GTM_EVENTS.UPGRADEPLANPOPUP_CONTACTUS_CLICK);
    }
    this.setState(prevState => ({ [stateName]: !prevState[stateName] }));
  };

  _upgradePlan = () => {
    buttonClickEvent(GTM_EVENTS.UPGRADEPLANPOPUP_UPGRADE_TO_PREMIUM_CLICK);
    const { data, pricingPlans } = this.props;
    const { selectedPlanAlias } = this.state;
    const planName = this._getPlanName(data.planInfo.upgradeTo);
    const isBtnTypeContact = pricingPlans[planName].btnTypeContact || false;

    if (isBtnTypeContact) {
      this._toggleModal("showContactUsModal");
    } else {
      // const { planAlias } = pricingPlans[planName].price[selectedPeriod];

      const CURRENT_PLAN_HASH = readDataFromLocalStorage("planHash");
      writeDataToLocalStorage("oldPlanHash", CURRENT_PLAN_HASH);

      const params = {};
      params[GTM_EVENT_PARAMS.PLAN_NAME] = planName;
      params[GTM_EVENT_PARAMS.PLAN_TYPE] = "Subscription";
      params[GTM_EVENT_PARAMS.POPUP_NAME] = "Upgrade Plan Popup";
      customGAEvent(GTM_CUSTOM_EVENTS.PAYMENT_START, params);

      this.props.getSubscriptionCheckoutSessionID(selectedPlanAlias);
    }
  };

  _onClosePopup = () => {
    buttonClickEvent(GTM_EVENTS.UPGRADEPLANPOPUP_CLOSE_CLICK);
    this.props.onClose();
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const { selectedPlan } = this.state;
    if (this.props.data) {
      const {
        data,
        data: { planInfo, generalInfo },
        pricingPlans,
        basicAndPremiumPlansData,
      } = this.props;

      const planName = this._getPlanName(data.planInfo.upgradeTo);
      // const planToUpgrade = pricingPlans[planName];
      let availableLimit = null;
      const count = this.props.meteringCounts[this.props.type] || null;
      const plansToUpgradeTo = [pricingPlans.Basic, pricingPlans.Premium];

      if (count) {
        const { limit, usage } = count;
        availableLimit = Math.max(0, limit - usage);
      }

      return (
        <Fragment>
          <Modal
            open
            center
            showCloseIcon={false}
            onClose={this._onClosePopup}
            classNames={{
              modal: "upgradeplan-modal-popup",
            }}
            closeOnOverlayClick={false}>
            <FontAwesomeIcon
              icon={["far", "times"]}
              onClick={this._onClosePopup}
              data-test="upgradeplan-close"
              className="upgradeplan-close-btn"
            />
            <div className="upgradeplan-container">
              <section className="upgradeplan-body">
                {/* left */}
                <div className="upgradeplan-left-section">
                  <div className="upgradeplan-title">
                    {/* {planInfo.icon && (
                      <span
                        role="img"
                        aria-label="icon"
                        className="upgradeplan-icon">
                        {planInfo.icon}
                      </span>
                    )} */}
                    {/* {planInfo.title &&
                      planInfo.title.replace("[x]", availableLimit)} */}
                    Upgrade to Revv {this.state.selectedPlan}
                  </div>
                  <div className="upgradeplan-description">
                    {basicAndPremiumPlansData &&
                      basicAndPremiumPlansData[this.state.selectedPlan]
                        .description}
                  </div>
                  <div className="upgradeplan-sub-title">
                    {/* {planInfo.subTitle}{" "}
                    {planInfo.showPlanName ? `${planToUpgrade.planName}` : ""} */}
                    Why upgrade to Revv&#39;s {this.state.selectedPlan} plan?
                  </div>
                  {basicAndPremiumPlansData &&
                    basicAndPremiumPlansData[
                      this.state.selectedPlan
                    ].features.map(feature => (
                      <div className="upgradeplan-feature-list">
                        <i>
                          {" "}
                          <FontAwesomeIcon icon={["far", "check-circle"]} />
                        </i>{" "}
                        {ReactHtmlParser(feature)}
                      </div>
                    ))}
                  {/* {basicAndPremiumPlansData &&
                    this.state.selectedPlan === "Basic" && (
                      <div className="upgradeplan-feature-list">
                        &nbsp; &nbsp; & more
                      </div>
                    )} */}
                  {/* <div className="upgradeplan-plans-container">
                    {planToUpgrade.price &&
                      Object.keys(planToUpgrade.price)
                        .map(key => planToUpgrade.price[key])
                        .map(price => (
                          <div
                            className={`upgradeplan-plan-section ${
                              price.period === this.state.selectedPeriod
                                ? "selected-plan"
                                : ""
                            }`}
                            role="button"
                            tabIndex={0}
                            onKeyPress={() => {}}
                            onClick={() =>
                              this.setState({ selectedPeriod: price.period })
                            }>
                            {planToUpgrade.bestValue === price.period && (
                              <div className="upgradeplan-most-popular">
                                Best value
                              </div>
                            )}
                            <div className="upgradeplan-period">
                              {price.period}
                            </div>
                            <div className="upgradeplan-price-monthly">
                              {`${price.pricePerMonth}/user/month`}
                            </div>
                            <div className="upgradeplan-price-yearly">
                              {price.pricePerYear}
                            </div>
                          </div>
                        ))}
                  </div> */}
                  <div className="upgradeplan-plans-container">
                    {plansToUpgradeTo.map(plan => (
                      <div
                        className={`upgradeplan-plan-section ${
                          selectedPlan === plan.planName && "selected-plan"
                        }`}
                        role="button"
                        tabIndex={0}
                        onKeyPress={() => {}}
                        onClick={() =>
                          this.setState({
                            selectedPlan: plan.planName,
                            selectedPlanAlias: plan.price.annually.planAlias,
                          })
                        }>
                        <div
                          className={`upgradeplan-most-popular ${
                            selectedPlan === plan.planName &&
                            "upgradeplan-most-popular-selected"
                          }`}>
                          {plan.planName}
                        </div>

                        {/* <div className="upgradeplan-period">
                              {price.period}dd
                            </div> */}
                        <div className="upgradeplan-price-monthly">
                          {plan.price.annually.pricePerYear.split(" ")[0]} per
                          year
                        </div>
                        <div className="upgradeplan-price-yearly">
                          {plan.price.annually.pricePerMonth}/user/month -
                          Billed annually
                        </div>
                      </div>
                    ))}
                  </div>
                  <div>
                    {CURRENT_USER &&
                    CURRENT_USER.roles &&
                    CURRENT_USER.roles.length > 0 &&
                    CURRENT_USER.roles[0].name === "User" ? (
                      <Button
                        type="four"
                        data-test="upgradeplans-subscribe"
                        className="upgradeplans-subscribe disabled">
                        <Tooltip
                          placement="top"
                          overlay="Please contact your company's Revv admin to upgrade">
                          <span>Contact to your Admin</span>
                        </Tooltip>
                      </Button>
                    ) : (
                      <Button
                        type="four"
                        data-test="upgradeplans-subscribe"
                        className="upgradeplans-subscribe"
                        onClick={() => this._upgradePlan()}>
                        {/* {planToUpgrade.btnTxt || "Subscribe"} */}
                        Upgrade to {this.state.selectedPlan}
                      </Button>
                    )}
                  </div>
                  <div className="upgradeplan-viewallplans">
                    <Button
                      data-test="upgradeplan-viewallplans-btn"
                      className="upgradeplan-viewallplans-btn"
                      onClick={() => {
                        this._toggleModal("showAllPlansModal");
                      }}>
                      View all plans
                    </Button>
                  </div>
                </div>
                {/* right */}
                <div className="upgradeplan-right-section">
                  <div className="upgradeplan-feature-image">
                    {generalInfo.imgSrc && (
                      <img
                        className="upgradepop-img"
                        alt="upgradepop"
                        src={generalInfo.imgSrc}
                      />
                    )}
                  </div>
                  <div className="upgradeplan-general-title">
                    {generalInfo.title}
                  </div>
                  <div className="upgradeplan-general-description">
                    {generalInfo.description}
                  </div>
                  {generalInfo.link && generalInfo.link.type === "contact" && (
                    <div
                      className="upgradepop-learn-more-link"
                      data-test="upgradepop-learn-more-link"
                      onClick={() => this._toggleModal("showContactUsModal")}
                      onKeyPress={() => {}}
                      role="button"
                      tabIndex="0">
                      {generalInfo.link.lablel}
                      {/**
                      <a
                      href={generalInfo.link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-test="upgradepop-learn-more-link"
                    />
                     */}
                    </div>
                  )}
                </div>
              </section>
            </div>
          </Modal>

          {this.state.showAllPlansModal && (
            <SeeAllPlansPopup
              onClose={() => this._toggleModal("showAllPlansModal")}
            />
          )}

          {this.state.showContactUsModal && (
            <PlanChangeRequest
              currentPlan={this.props.currentPlan}
              onClose={() => this._toggleModal("showContactUsModal")}
            />
          )}
        </Fragment>
      );
    }
    return null;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { metering: meteringCounts, pricingInfo } = state.CommonStore;

  const { plans: pricingPlans, planMapping } = pricingInfo;
  const data =
    pricingInfo.upgradePopup &&
    pricingInfo.upgradePopup[UPGRADE_POPUP_TYPE[ownProps.type].name];
  let basicAndPremiumPlansData = null;
  if (pricingInfo.upgradePopup) {
    basicAndPremiumPlansData = {
      Basic: {
        features: pricingInfo.upgradePopup.basic.planInfo.planIncludes,
        description: pricingInfo.upgradePopup.basic.planInfo.description,
      },
      Premium: {
        features: pricingInfo.upgradePopup.premium.planInfo.planIncludes,
        description: pricingInfo.upgradePopup.premium.planInfo.description,
      },
    };
  }

  return {
    data,
    meteringCounts,
    planMapping,
    pricingPlans,
    basicAndPremiumPlansData,
  };
};

const mapDispatchToProps = {
  getSubscriptionCheckoutSessionID,
  fetchPricingInfoAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpgradePopUpV2);
